import { getSearchSumberDana, getSearchSlikSektorEkonomi, getSearchLembagaRating, getSearchSlikPihakKetiga, getSearchJenisPenggunaan, getSearchSlikJenisPenggunaan, getSearchSlikJenisKredit, getSearchSidKategoriDebitur, getSearchSidSektorEkonomiObox, getSearchSidSektorEkonomi, getSearchSlikSifat, getSearchSlikOrientasiPenggunaan, getSearchSandiBiGovKredit, getSearchSidGolPenjamin, getSearchSandiBiSifat, getSearchSandiBiKur, getSearchSandiBiP2pl, getSearchSandiBiTksAtmr, getSearchSandiBiIkatanHukum, getSearchSandiBiIkatanHukumSlik, getSearchSandiBiJenisAgunan, getSearchSandiBiJenisAgunanSlik, getSearchSandiBiJenisDokumen, getSearchSandiBiFasilitasSlik, getSearchSandiBiGolDebitur, getSearchSandiBiGolKreditur, getSearchSandiBiGroupDebitur, getSearchSandiBiJenisAkad, getSearchSandiBiHubunganBank, getSearchSandiBiHubunganLjkSlik, getSearchSandiBiLokasi, getSearchSandiBiPemilik, } from "../../../core/services/master/finance.service";
import { useQuery } from "@tanstack/react-query";
export const useGetSearchSumberDana = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sumberdana", searchParams],
        queryFn: () => getSearchSumberDana(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSlikSektorEkonomi = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sliksektorekonomi", searchParams],
        queryFn: () => getSearchSlikSektorEkonomi(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchLembagaRating = (searchParams) => {
    return useQuery({
        queryKey: ["master", "lembagarating", searchParams],
        queryFn: () => getSearchLembagaRating(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSlikPihakKetiga = (searchParams) => {
    return useQuery({
        queryKey: ["master", "slikpihakketiga", searchParams],
        queryFn: () => getSearchSlikPihakKetiga(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchJenisPenggunaan = (searchParams) => {
    return useQuery({
        queryKey: ["master", "jenispenggunaan", searchParams],
        queryFn: () => getSearchJenisPenggunaan(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSlikJenisPenggunaan = (searchParams) => {
    return useQuery({
        queryKey: ["master", "slikjenispenggunaan", searchParams],
        queryFn: () => getSearchSlikJenisPenggunaan(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSlikJenisKredit = (searchParams) => {
    return useQuery({
        queryKey: ["master", "slikjeniskredit", searchParams],
        queryFn: () => getSearchSlikJenisKredit(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSidKategoriDebitur = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sidkategoridebitur", searchParams],
        queryFn: () => getSearchSidKategoriDebitur(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSidSektorEkonomiObox = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sidsektorekonomiobox", searchParams],
        queryFn: () => getSearchSidSektorEkonomiObox(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSidSektorEkonomi = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sidsektorekonomi", searchParams],
        queryFn: () => getSearchSidSektorEkonomi(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSlikSifat = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sliksifatkredit", searchParams],
        queryFn: () => getSearchSlikSifat(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSlikOrientasiPenggunaan = (searchParams) => {
    return useQuery({
        queryKey: ["master", "slikorientasipenggunaan", searchParams],
        queryFn: () => getSearchSlikOrientasiPenggunaan(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSandiBiGovKredit = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sandibigovkredit", searchParams],
        queryFn: () => getSearchSandiBiGovKredit(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSidGolPenjamin = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sidgolpenjamin", searchParams],
        queryFn: () => getSearchSidGolPenjamin(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSandiBiSifat = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sandibisifat", searchParams],
        queryFn: () => getSearchSandiBiSifat(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSandiBiKur = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sandibikur", searchParams],
        queryFn: () => getSearchSandiBiKur(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSandiBiP2pl = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sandibip2pl", searchParams],
        queryFn: () => getSearchSandiBiP2pl(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSandiBiTksAtmr = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sandibitksatmr", searchParams],
        queryFn: () => getSearchSandiBiTksAtmr(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSandiBiIkatanHukum = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sandibiikatanhukum", searchParams],
        queryFn: () => getSearchSandiBiIkatanHukum(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSandiBiIkatanHukumSlik = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sandibiikatanhukumslik", searchParams],
        queryFn: () => getSearchSandiBiIkatanHukumSlik(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSandiBiJenisAgunan = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sandibijenisagunan", searchParams],
        queryFn: () => getSearchSandiBiJenisAgunan(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSandiBiJenisAgunanSlik = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sandibijenisagunanslik", searchParams],
        queryFn: () => getSearchSandiBiJenisAgunanSlik(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSandiBiFasilitasSlik = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sandibifasilitasslik", searchParams],
        queryFn: () => getSearchSandiBiFasilitasSlik(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSandiBiGolDebitur = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sandibigoldebitur", searchParams],
        queryFn: () => getSearchSandiBiGolDebitur(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSandiBiGolKreditur = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sandibigolkreditur", searchParams],
        queryFn: () => getSearchSandiBiGolKreditur(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSandiBiGroupDebitur = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sandibigroupdebitur", searchParams],
        queryFn: () => getSearchSandiBiGroupDebitur(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSandiBiJenisAkad = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sandibijenisakad", searchParams],
        queryFn: () => getSearchSandiBiJenisAkad(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSandiBiHubunganBank = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sandibihubunganbank", searchParams],
        queryFn: () => getSearchSandiBiHubunganBank(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSandiBiHubunganLjkSlik = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sandibihubunganljkslik", searchParams],
        queryFn: () => getSearchSandiBiHubunganLjkSlik(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSandiBiLokasi = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sandibilokasi", searchParams],
        queryFn: () => getSearchSandiBiLokasi(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSandiBiPemilik = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sandibipemilik", searchParams],
        queryFn: () => getSearchSandiBiPemilik(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
export const useGetSearchSandiBiJenisDokumen = (searchParams) => {
    return useQuery({
        queryKey: ["master", "sandibijenisdokumen", searchParams],
        queryFn: () => getSearchSandiBiJenisDokumen(searchParams),
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
